var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottomNav"},_vm._l((_vm.navData),function(v){return _c('div',{key:v.id,staticClass:"every",style:({ fontSize: _vm.currentInd == v.id ? `22px` : `20px` }),on:{"click":function($event){return _vm.changeNav(v.id)}}},[(_vm.currentInd == v.id)?_c('div',{staticClass:"img"}):_vm._e(),_vm._v(" "+_vm._s(v.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }